








































































import Vue from 'vue';
import {API, getDesserts} from '@/api';
import { mapActions } from 'vuex';
import AgregarCuentaBancaria from '@/components/cuentas/AgregarCuentaBancaria.vue';

export default Vue.extend({
  components: { AgregarCuentaBancaria },
  data: () => ({
    singleSelect: false,
    row: {},
    selected: {},
    headers: [
      { text: 'Propietario', value: 'propCuenta' },
      { text: 'Cuenta', value: 'numCuenta' },
      { text: 'Banco', value: 'banco' },
      { text: 'CLABE', value: 'clabe' },
      { text: 'Tipo', value: 'principal' },
      { text: 'Borrada', value: 'eliminada' },
    ],
    total: 0,
    Cuentas: [],
    loading: true,
    options: {},
    dialog: false,
    readonly: true,
  }),
  methods: {
    ...mapActions(['getCuentasList']),
    open(event) {
      console.log('Current:', event);
      this.selected = event;
      this.dialog = true;
      this.readonly = true;
    },
    async loadData() {
      try {
        const admin = this.$store.getters.getAdmin;
        const condo = this.$store.getters.getCondo;
        this.loading = true;
        const result = await this.$store.dispatch('getCuentasList', {admin, condo, options: this.options});
        console.debug('getCuentasList result: %o', result);
        this.total = result.totalElements;
        // this.Cuentas = result.content;
        this.Cuentas = result;
        console.log('CtaBancarias: ', this.Cuentas);
        console.log('CONCEPTO: %o', this.Conceptos);
      } catch (e) {
        this.$toast.error(e);
      }
      this.loading = false;
    },
    async pageEventHandler(page) { // cargar mas registros
      this.loadData();
    },
    async reloadGrid(event) {
      this.loadData();
    },
  },
  watch: {
    dialog() {
      if (!this.dialog) {
        this.selected = {};
      }
    },
  },
});
